import { get, post, put, fileDown } from "@/utils/request";

import apiMap from "@/config";

const riskApi = apiMap.riskApi

export const getBasicInfo = data =>
  get(`${riskApi}/risk/riskUser/getUserInfo`, data);

export const getBetInfo = data =>
  post(`${riskApi}/risk/riskUser/getBettingInfo`, data);

export const getBetChildInfo = data =>
  post(`${riskApi}/risk/riskUser/getBettingByKeyType`, data);

export const getBetTerminal = data =>
  post(`${riskApi}/risk/riskUser/getTerminalDeviceList`, data);

export const getLoginLog = data =>
  post(`${riskApi}/risk/riskUser/findUserLoginByPage`, data);

export const getIpHistory = data =>
  post(`${riskApi}/risk/userIpHistory/page`, data);

export const getIpItemInfo = data =>
  post(`${riskApi}/risk/userIpHistory/listByIp`, data);

export const getDeviceHistory = data =>
  post(`${riskApi}/risk/userDeviceHistory/page`, data);

export const getDeviceItemInfo = data =>
  post(`${riskApi}/risk/userDeviceHistory/listByDevice`, data);

export const getOrderList = data =>
  post(`${riskApi}/risk/riskOrder/getOrderList`, data);

export const getExport = (data, fileName) =>
  fileDown(`${riskApi}/risk/riskOrder/exportExcel`, data, fileName);

export const getMarketList = (data) =>
  post(`${riskApi}/risk/riskOrder/findMarketListBySport`, data);

export const getPeriodList = data =>
  post(`${riskApi}/risk/riskOrder/findPeriodsBySportId`, data);

export const getProfitList = (data, type, conf) =>
  post(`${riskApi}/risk/riskOrder/findUserProList`, data, type, conf);

export const getProfitExport = (data, fileName) =>
  fileDown(`${riskApi}/risk/riskOrder/exportProfitExcel`, data, fileName);

export const getChartList = (data) =>
  post(`${riskApi}/risk/riskOrder/findListByUserId`, data);

export const getCashoutList = data =>
  get(`${riskApi}/risk/riskOrder/getSettledCashoutList`, data);

export const getOddsList = data =>
  post(`${riskApi}/risk/riskOrder/findOddsLogs`, data);

export const getModifyLog = data =>
  get(`${riskApi}/risk/user/queryOperationLogById`, data);

export const pinCheck = data =>
  post(`${riskApi}/risk/user/pinCheck`, data);

export const getTcsSportList = data =>
  get(`${riskApi}/tcs/common/findCurrentSports`, data);

